import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInput from './inputs/text-input'
import PhoneInput from './inputs/phone-input'
import { patchForm, postForm } from '../../ajax'
import FlashAlert from '../flash-alert'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

function OrganizerForm({partnerId, data, onClose, onCreate, onUpdate}) {
  const isNew = !data.id
  const requiredMsg = 'Is required'
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState()
  const [countryCode, setCountryCode] = useState()
  const { register, reset, setValue, handleSubmit, formState: { errors } } = useForm()

  useEffect(() => {
    reset(_.omit(data, 'id'))
  }, [data])

  const validatePresence = (value) => {
    if (!value.trim()) return requiredMsg
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    const phonePresent = data.phone.trim().length > 2
    formData.append('organizer[first_name]', data.first_name)
    formData.append('organizer[last_name]', data.last_name)
    formData.append('organizer[email]', data.email)
    formData.append('organizer[phone]', phonePresent ? data.phone : '')
    formData.append('organizer[country_code]', phonePresent ? countryCode : '')
    return formData
  }

  const submitUrl = () => {
    if (isNew) return `/admins/partners/${partnerId}/organizers.json`

    return `/admins/partners/${partnerId}/organizers/${data.id}.json`
  }

  const onSubmit = async (data) => {
    let formData = prepareFormData(data)
    const submitMethod = isNew ? postForm : patchForm

    setLoading(true)
    const response = await submitMethod(submitUrl(), formData)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      const organizer = json.organizer
      isNew ? onCreate(organizer) : onUpdate(organizer)
    }
  }

  return (
    <Modal dialogClassName='organizer-modal' backdrop='static' container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? 'New Admin' : 'Edit Admin'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} /> }
        { loading && <div className='animated-spinner'></div> }
        <form className={'organizer-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            {...register('first_name', { required: 'Is required', validate: validatePresence })}
            label='First Name'
            error={errors && errors.first_name}
            onChange={e => setValue('first_name', e.target.value)}
          />
          <TextInput
            {...register('last_name', { required: 'Is required', validate: validatePresence })}
            label='Last Name'
            error={errors && errors.last_name}
            onChange={e => setValue('last_name', e.target.value)}
          />
          <TextInput
            {...register('email', { 
              required: 'Is required', 
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address'
              }
            })}
            label='Email'
            error={errors && errors.email}
            onChange={e => setValue('email', e.target.value)}
          />
          <PhoneInput
            {...register('phone')}
            label='Phone'
            error={errors.phone}
            defaultValue={formatPhoneNumberIntl(data.phone)}
            onChange={(p, c) => {
              setCountryCode(c)
              setValue('phone', p)
            }}
          />
          <div className='form-action'>
            <input type='submit' value={isNew ? 'Create' : 'Update'} className='btn btn-primary' />
            <button className='btn btn-default' onClick={onClose} type='button'>Cancel</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

OrganizerForm.propTypes = {
  partnerId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}

export default OrganizerForm

